// src/hooks/products/useRestoreProduct.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreProduct } from "../../api/apiProducts";
import parseError from "../../utils/parseError";

const useRestoreProduct = () => {
    const queryClient = useQueryClient();

    const {
        mutate: restoreProductMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: restoreProduct,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["products"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore product");
        },
    });

    return {
        restoreProduct: restoreProductMutate,
        isRestore: isPending || isLoading,
    };
};

export default useRestoreProduct;
